import { ImportTripsErrorCodes } from '../../../enums';

export interface IImportTripsError {
    column?: string;
    row?: number;
    code: ImportTripsErrorCodes;
    expectedValue?: string;
    givenValue?: string;
}

export interface IImportTripsDto {
    success: boolean;
    errors: IImportTripsError[];
    rowsCount: number;
    createdTripsCount?: number;
    updatedTripsCount?: number;
    filename: string;
}
